import React, { useContext } from 'react';
import { Modal as RBModal } from 'react-bootstrap';
import { IHaiModalHeader } from '../IModal';
import { ModalContext } from '../ModalContext';
import { Icon } from '@hai/ui-react';
import { ThemedComponent } from '@hai/ui-react/dist/ThemeContext';

const componentPath = 'components/Modal/Modal';

const BaseModalHeader = (props: IHaiModalHeader) => {
  const { alignment = 'left', className = '', closeButton = false, children, ...rest } = props;
  const headerRef = React.useRef(null);
  let headerClassName;
  {
    children ? (headerClassName = 'HaiModalHeader') : (headerClassName = 'HaiModalHeaderNoChild');
  }

  const modalContext = useContext(ModalContext);
  const { onHide } = modalContext;

  const customCloseButton = (
    <span
      className="modal-header-close-btn"
      data-auto="modal-header-close-btn"
      onClick={closeButton && onHide}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          closeButton && onHide();
        }
      }}
    >
      <Icon color="haiui-gray-05" iconname="Close" size="sm2" tabIndex={0} />
    </span>
  );

  return (
    <RBModal.Header
      ref={headerRef}
      className={`${headerClassName} ${alignment} ${className}`}
      closeButton={false}
      onHide={onHide}
      {...{ theme: 'argon' }}
      {...(rest as any)}
    >
      {closeButton && customCloseButton}
      {props.children}
    </RBModal.Header>
  );
};

const ModalHeader = (props: IHaiModalHeader) => ThemedComponent(BaseModalHeader, props, componentPath);

export default ModalHeader;
